<template>
  <v-dialog
    v-model="getActive"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    max-width="400"
    :retain-focus="false"
  >
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on" style="min-width: 0; width: 20px">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </template>
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular"
      >
        <v-icon
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          class="mr-3"
          medium
          >mdi-comment-question-outline</v-icon
        >
        {{ $t("msgConfirm") }}
      </v-card-title>
      <v-card-text class="pt-6 pb-6">{{
        $t("userNewOrderBasicGoBack2")
      }}</v-card-text>
      <v-card-actions
        :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
        :style="
          getTheme() == 'dark'
            ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
            : 'background-color: white; border-top: 1px solid lightgray;'
        "
      >
        <v-spacer></v-spacer>
        <v-btn color="primary" text class="mx-0" @click="clickNo">{{
          $t("lmBtnNo")
        }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" text class="mx-0" @click="clickYes">{{
          $t("lmBtnYes")
        }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-show-go-back",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      getActive: false,
    };
  },
  methods: {
    clickYes: function () {
      this.$emit("clickYes");
    },
    clickNo: function () {
      this.getActive = false;
    },
  },
  mounted() {
    this.getActive = this.active;
  },
};
</script>

<style scoped>
</style>